// extracted by mini-css-extract-plugin
export default {"container":"_3ht83X","contentWrapper":"_2SZb9K","content":"_1UXolr"};